// extracted by mini-css-extract-plugin
export default {"tarotFlow":"tarot-flow-wrapper_tarotFlow__xRS++"};